export default "__VITE_ASSET__5ccb79e7__"